const SKILL_EVENTS = [
  'EXECUTION_STARTED',
  'ITERATION_STARTED',
  'TOOL_CALL_REQUESTED',
  'TOOL_CALL_COMPLETED',
  'TOOL_CALL_FAILED',
  'ITERATION_ENDED',
  'EXECUTION_COMPLETED'
];

export function getGenerationStatus(message) {

  if (!message.metadata) {
    return null;
  }

  var generationState = message.metadata.generationState;

  if (!generationState) {
    return null;
  }

  return generationState.status;

}

export function getLastAction(message) {

  var actions = message.metadata.generationState.actions;

  if (!actions || actions.length === 0) {
    return null;
  }

  return actions[actions.length - 1];

}

function formatSkillEvent(event) {
  const skillName = event.skill?.name || 'Skill';
  const toolName = event.tool?.name || 'tool';
  /* eslint-disable */
  switch (event.type) {
    case 'EXECUTION_STARTED':
      return `Using ${skillName}`;

    case 'ITERATION_STARTED':
      return `Using ${skillName}`;

    case 'TOOL_CALL_REQUESTED':
      return `Using ${skillName}:${toolName}`;

    case 'TOOL_CALL_COMPLETED':
      return `Completed ${skillName}:${toolName}`;

    case 'TOOL_CALL_FAILED':
      return `${skillName}:${toolName} failed`;

    case 'ITERATION_ENDED':
      return `${skillName} continuing`;

    case 'EXECUTION_COMPLETED':
      return `${skillName} finished`;

    default:
      return `${skillName} updated`;
  }
  /* eslint-enable */
}

export function formatActionType(action) {

  if (!action || typeof action.type !== 'string') {
    return '';
  }

  var type = action.type.trim();

  if (!type) {
    return '';
  }

  if (SKILL_EVENTS.includes(type) === true) {
    return formatSkillEvent(action);
  }

  var status = action.status;
  var normalizedType = type
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  var isActivityPhrase = normalizedType === normalizedType.toLowerCase();

  if (status === 'COMPLETED') {
    return normalizedType + ' completed';
  }

  if (status === 'STARTED') {
    if (isActivityPhrase) {
      return normalizedType.replace(/\b\w/g, function capitalizeFirst(char) {
        return char.toUpperCase();
      });
    }

    return normalizedType + ' started';
  }

  return normalizedType;

}

export function hasContent(message) {

  var serializedContent = message.serializedContent;

  return serializedContent.text.trim().length > 0;

}

export function svgFromString(svgText) {
  // eslint-disable-next-line no-undef
  const parser = new DOMParser();
  const doc = parser.parseFromString(svgText, 'image/svg+xml');
  return doc.documentElement;
}